import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Header from '../components/Header';
import Loading from '../components/LoadingError/Loading';
import Message from '../components/LoadingError/Error';
import moment from 'moment';
import 'moment/locale/es';
import { doPayment, findOrder } from '../service/OrdersService';
import { ResponsiveContext } from '../contexts/ResponsiveContext';
import { adminColors } from '../constants/constantsValues';

const OrderScreen = ({ user }) => {
  const [order, setOrder] = useState();
  const [loading, setLoading] = useState(true);
  const [loadingPay] = useState(false);
  const [error, setError] = useState();
  const [showCustomer, setShowCustomer] = useState(false);
  const [showOrderInfo, setShowOrderInfo] = useState(false);
  const [showDelivery, setShowDelivery] = useState(false);

  const params = useParams();
  const orderId = params.id;

  moment.locale('es');

  const { is775, is575, is350, is450 } = useContext(ResponsiveContext);

  if (!loading) {
    const addDecimals = (num) => {
      return (Math.round(num * 100) / 100).toFixed(2);
    };

    order.itemsPrice = addDecimals(
      order.orderItems?.reduce(
        (acc, item) => acc + (item.price / 1.21) * item.qty,
        0
      )
    );
  }

  useEffect(() => {
    if (user && orderId) {
      findOrder(orderId)
        .then((order) => {
          setOrder(order[0]);
          setLoading(false);
        })
        .catch((e) => setError(e));
    }
  }, [user, orderId]);

  const handleMenu = (e) => {
    if (e === 'showCustomer') {
      setShowOrderInfo(false);
      setShowDelivery(false);
      setShowCustomer((old) => !old);
    }
    if (e === 'showOrderInfo') {
      setShowCustomer(false);
      setShowDelivery(false);
      setShowOrderInfo((old) => !old);
    }
    if (e === 'showDelivery') {
      setShowCustomer(false);
      setShowOrderInfo(false);
      setShowDelivery((old) => !old);
    }
  };

  const handlePayment = () => {
    setLoading(true);
    const payment = {
      orderId: orderId,
      amount: order?.totalPrice.toFixed(2).replace('.', ''),
      email: order?.user?.email,
      address: order?.userAddress?.address,
      city: order?.userAddress?.city,
      postalCode: order?.userAddress?.postalCode,
    };

    doPayment(payment)
      .then((url) => {
        window.location.replace(url.hppPayByLink);
      })
      .catch((error) => setError(error.response.data.message));
  };

  return (
    <>
      <Header searcherDisabled={true} shopLink={true} />
      <div className='container'>
        {error && <Message variant='alert-danger'>{error}</Message>}
        {loading ? (
          <Loading />
        ) : (
          <>
            <div
              className={
                !is575
                  ? 'd-flex flex-row justify-content-around mt-5'
                  : 'row order-detail'
              }
            >
              <div className='col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0'>
                <div className='row '>
                  <div
                    className={`col-md-4 center ${
                      !is775 ? 'd-flex justify-content-center' : ''
                    }`}
                    onClick={() => handleMenu('showCustomer')}
                  >
                    <div className='alert-success order-box'>
                      <i
                        className='fas fa-user'
                        style={{
                          color: showCustomer && !is775 ? 'orange' : 'black',
                        }}
                      ></i>
                    </div>
                  </div>
                  {is775 && (
                    <div className={`${!is775 && 'mt-3'} col-md-8 center`}>
                      <h5>
                        <strong>Cliente</strong>
                      </h5>
                      <p>
                        {order?.user.name} {order?.user.lastName}
                      </p>
                      <p>{order?.user.email}</p>
                      <p>{order?.user.phone}</p>
                    </div>
                  )}
                </div>
              </div>
              {/* 2 */}
              <div className='col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0'>
                <div className='row'>
                  <div
                    className={`col-md-4 center ${
                      !is775 ? 'd-flex justify-content-center' : ''
                    }`}
                    onClick={() => handleMenu('showOrderInfo')}
                  >
                    <div className='alert-success order-box'>
                      <i
                        className='fas fa-truck-moving'
                        style={{
                          color: showOrderInfo && !is775 ? 'orange' : 'black',
                        }}
                      ></i>
                    </div>
                  </div>
                  {is775 && (
                    <div className={`${!is775 && 'mt-3'} col-md-8 center`}>
                      <h5>
                        <strong>Información del Pedido</strong>
                      </h5>
                      <p>
                        {order?.deliveryMethod === 'tienda'
                          ? 'Recogida: '
                          : 'Entregar: '}
                        {order?.deliveryMethod &&
                        order.deliveryMethod === 'domicilio'
                          ? 'Domicilio'
                          : 'Tienda'}
                      </p>
                      <p>
                        Pago:{' '}
                        {order?.paymentMethod &&
                         order.paymentMethod === 'mano'
                          ? 'En mano'
                          : 'Tarjeta de Crédito'}
                      </p>
                      <p>
                        {' '}
                        <u>Estado</u>:{' '}
                        <b>
                          {order.isPaid
                            ? `Pagado ${moment(order.paidAt).calendar()}`
                            : 'Sin pagar'}
                        </b>
                      </p>
                    </div>
                  )}
                </div>
              </div>
              {/* 3 */}
              <div className='col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0'>
                <div className='row d-flex'>
                  <div
                    className={`col-md-4 center ${
                      !is775 ? 'd-flex justify-content-center' : ''
                    }`}
                    onClick={() => handleMenu('showDelivery')}
                  >
                    <div className='alert-success order-box'>
                      <i
                        className='fas fa-map-marker-alt'
                        style={{
                          color: showDelivery && !is775 ? 'orange' : 'black',
                        }}
                      ></i>
                    </div>
                  </div>
                  {is775 && (
                    <div className={`${!is775 && 'mt-3'} col-md-8 center`}>
                      <h5>
                        <strong>
                          {order?.deliveryMethod === 'tienda'
                            ? 'Recogida: '
                            : 'Entregar: '}
                        </strong>
                      </h5>
                      <p>
                        Dirección:{' '}
                        {order?.deliveryMethod
                          ? order?.deliveryMethod === 'tienda'
                            ? 'C. de Virgen de Lluc, 4, 28027, Madrid'
                            : `${order?.deliveryAddress?.address}, ${order?.deliveryAddress?.flat}, ${order?.deliveryAddress?.postalCode}, ${order?.deliveryAddress?.city}  `
                          : 'Sin definir'}{' '}
                      </p>
                      <p>
                        {' '}
                        <u>Estado</u>:{' '}
                        <b>
                          {order.isDelivered
                            ? `Entregado ${moment(
                                order.deliveredAt
                              ).calendar()}`
                            : 'Sin entregar'}
                        </b>
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {!is775 && (
              <div className={is350 ? 'mx-5' : 'mx-1'}>
                {showCustomer && (
                  <div>
                    <h6>
                      <strong>Cliente</strong>
                    </h6>
                    <p>
                      {order?.user.name} {order?.user.lastName}
                    </p>
                    <p>{order?.user.email}</p>
                    <p>{order?.user.phone}</p>
                  </div>
                )}
                {showOrderInfo && (
                  <div>
                    <h6>
                      <strong>Información del Pedido</strong>
                    </h6>
                    <p>
                      {order?.deliveryMethod === 'tienda'
                        ? 'Recogida: '
                        : 'Entregar: '}
                      {order?.deliveryMethod &&
                      order.deliveryMethod === 'domicilio'
                        ? 'Domicilio'
                        : 'Tienda'}
                    </p>
                    <p>
                      Pago:
                      {order?.paymentMethod && order.paymentMethod === 'mano'
                        ? 'En mano'
                        : 'Tarjeta de Crédito'}
                    </p>
                  </div>
                )}
                {showDelivery && (
                  <div>
                    <h6>
                      <strong>
                        {order?.deliveryMethod === 'tienda'
                          ? 'Recogida:'
                          : 'Entregar:'}
                      </strong>
                    </h6>
                    <p>
                      Dirección:{' '}
                      {order?.deliveryMethod
                        ? order?.deliveryMethod === 'tienda'
                          ? 'C. de Virgen de Lluc, 4, 28027, Madrid'
                          : `${order?.deliveryAddress?.address}, ${order?.deliveryAddress?.flat}, ${order?.deliveryAddress?.postalCode}, ${order?.deliveryAddress?.city}  `
                        : 'Sin definir'}{' '}
                    </p>
                  </div>
                )}
              </div>
            )}

            <div className='row order-products justify-content-between'>
              <div className='col-lg-8'>
                {order?.orderItems?.length === 0 ? (
                  <Message variant='alert-info mt-5'>
                    Tu carrito está vacío
                  </Message>
                ) : (
                  <>
                    {order?.orderItems?.map((item, index) => (
                      <div className='order-product row' key={index}>
                        <div className='col-md-3 col-6'>
                          <img src={item.image} alt={item.name} />
                        </div>
                        <div className='col-md-4 col-6 d-flex align-items-center'>
                          <Link to={`/products/${item.productId}`}>
                            <h6>{item.name}</h6>
                          </Link>
                        </div>
                        <div className='mt-3 mt-md-0 col-md-3 col-6 d-flex flex-row align-items-center justify-content-around '>
                          <div className='d-flex flex-row align-items-center'>
                            {is450 ||
                              (is775 && <h4 className='mb-0 fs-4 me-1'>T:</h4>)}
                            <h6 className='fs-5'>{item.size}</h6>
                          </div>
                          <div className='d-flex flex-row align-items-center'>
                            {is450 ||
                              (is775 && <h4 className='mb-0 fs-4 me-1'>C:</h4>)}
                            <div
                              className='mx-1 mb-1 d-flex align-items-center'
                              style={{
                                width: '20px',
                                height: '20px',
                                backgroundColor: `${
                                  adminColors.filter(
                                    (el) => el.name === item.color
                                  )[0]?.color
                                }`,
                                border: '1px solid black',
                                borderRadius: '50%',
                                cursor: 'pointer',
                              }}
                              key={item.color}
                            ></div>
                          </div>
                          <div className='d-flex flex-row align-items-center'>
                            <h6 className='fs-5'>{item.qty} Uds</h6>
                          </div>
                        </div>

                        <div className='mt-3 mt-md-0 col-md-2 col-6 align-items-end  d-flex flex-column justify-content-center '>
                          {/* <h4>SUBTOTAL</h4> */}
                          <h6>
                            {(item.qty * item.price)
                              .toString()
                              .replace('.', ',')}
                            {(item.qty * item.price)
                              .toString()
                              .replace('.', ',')
                              .split(',')[1]
                              ? (item.qty * item.price)
                                  .toString()
                                  .replace('.', ',')
                                  .split(',')[1].length === 1
                                ? '0'
                                : ''
                              : ',00'}{' '}
                            €
                          </h6>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
              {/* total */}
              <div className='col-lg-3 d-flex align-items-end flex-column mt-5 subtotal-order'>
                <table className='table table-bordered'>
                  <tbody>
                    <tr>
                      <td>
                        <strong>Productos</strong>
                      </td>
                      <td className='d-flex justify-content-end'>
                        {order?.itemsPrice.toString().replace('.', ',')}
                        {order?.itemsPrice
                          .toString()
                          .replace('.', ',')
                          .split(',')[1]
                          ? order?.itemsPrice
                              .toString()
                              .replace('.', ',')
                              .split(',')[1].length === 1
                            ? '0'
                            : ''
                          : ',00'}{' '}
                        €
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Envío</strong>
                      </td>
                      <td className='d-flex justify-content-end'>
                        {order?.shippingPrice.toString().replace('.', ',')}
                        {order?.shippingPrice
                          .toString()
                          .replace('.', ',')
                          .split(',')[1]
                          ? order?.shippingPrice
                              .toString()
                              .replace('.', ',')
                              .split(',')[1].length === 1
                            ? '0'
                            : ''
                          : ',00'}{' '}
                        €
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>IVA</strong>
                      </td>
                      <td className='d-flex justify-content-end'>
                        {(order?.taxPrice).toString().replace('.', ',')}
                        {order?.taxPrice
                          .toString()
                          .replace('.', ',')
                          .split(',')[1]
                          ? order?.taxPrice
                              .toString()
                              .replace('.', ',')
                              .split(',')[1].length === 1
                            ? '0'
                            : ''
                          : ',00'}{' '}
                        €
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Total</strong>
                      </td>
                      <td className='d-flex justify-content-end'>
                        {order.totalPrice &&
                          order.totalPrice.toString().replace('.', ',')}
                        {order.totalPrice &&
                        order.totalPrice
                          .toString()
                          .replace('.', ',')
                          .split(',')[1]
                          ? order.totalPrice
                              .toString()
                              .replace('.', ',')
                              .split(',')[1].length === 1
                            ? '0'
                            : ''
                          : ',00'}{' '}
                        €
                      </td>
                    </tr>
                  </tbody>
                </table>
                {!order.isPaid && order.paymentMethod !== 'mano' && (
                  <div className='col-12'>
                    {loadingPay && <Loading />}
                    <div className='col-12 d-flex justify-content-md-end mt-3 mt-md-0'>
                      <button
                        onClick={handlePayment}
                        style={{ backgroundColor: 'green' }}
                      >
                        Procesar el pago
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default OrderScreen;
